import React from 'react'
import { Grid, PageSection as Section } from '@superhi/design'

import Instructor from 'src/components/Instructor'

export const ID = 'INSTRUCTORS'

const GRID_1_ROW_GAP = { small: 32, medium: 40 }

const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: [2, 7],
  large: [3, 10],
}

const GRID_1_CELL_SPAN_2: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: [2, 7],
  large: 6,
}

type Props = {
  instructors: React.ComponentProps<typeof Instructor>[]
}

const Contents: React.FC<React.PropsWithChildren<Props>> = ({ instructors = [] }) => (
  <Section
    id={ID}
    title="Your instructors"
    subtitle="Our instructors have decades of professional experience, have spoken at international conferences and have won countless web design awards."
    subtitleMaxWidth={38}
    noBottomPadding
    headingLevel={2}
  >
    <Grid rowGap={GRID_1_ROW_GAP}>
      {instructors.map((instructor) => (
        <Grid.Cell
          span={instructors.length === 1 ? GRID_1_CELL_SPAN_1 : GRID_1_CELL_SPAN_2}
          key={instructor.name}
        >
          <Instructor {...instructor} headingLevel={3} />
        </Grid.Cell>
      ))}
    </Grid>
  </Section>
)

export default Contents
